// language-selector.component.ts
import { CommonModule } from '@angular/common';
import { Component, Output, EventEmitter } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { UserSessionStorageService } from '../../data-access-layer/services/user-sessions.service';

@Component({
  selector: 'app-language-selector',
  templateUrl: '../templates/language-selector.component.html',
  styleUrls: ['../templates/styles/language-selector.component.css'],
  imports: [CommonModule],
  standalone: true
})
export class LanguageSelectorComponent {
  langs = ['ru', 'en'];
  langLabels: Record<string, string> = { ru: 'Русский', en: 'English' };

  constructor(public transloco: TranslocoService, public sessionService: UserSessionStorageService) { }

  @Output() langChange = new EventEmitter<string>();

  isOpen = false;

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  selectLang(lang: string) {
    this.transloco.setActiveLang(lang);
    this.langChange.emit(lang);
    this.isOpen = false;

    this.sessionService.setItem('lang', lang);
  }
}
